import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import ModalContainer from '../Modals/ModalContainer'
import { hideModal } from '../../redux/actions'

function PartnerArchiveModal({
  partner,
  listings,
  onClickSubmit,
}) {
  const dispatch = useDispatch()
  const [processing, setProcessing] = useState(false)

  const handleClose = () => {
    dispatch(hideModal())
  }

  return (
    <ModalContainer
      title={listings.length > 0 ? 'Unable to Archive Partner' : 'Archive Partner'}
      maxWidth="sm"
      fullWidth="true"
      hideModal={handleClose}
      processing={processing}
      actions={
        listings.length > 0
          ? {
            secondaryAction: {
              label: 'Close',
              onClick: handleClose,
            },
          }
          : {
            primaryAction: {
              label: 'Archive',
              onClick: async () => {
                setProcessing(true)

                try {
                  await onClickSubmit(partner.id)
                } finally {
                  setProcessing(false)
                }
              },
            },
            secondaryAction: {
              label: 'Cancel',
              onClick: handleClose,
            },
          }
      }
    >
      <Box>
        {listings.length > 0
          ? 'We are unable to archive the partner because it has active listings. Please archive or move the listings under the partner and try again.'
          : 'Are you sure you want to archive this partner? This change cannot be reversed.'}
      </Box>
    </ModalContainer>
  )
}

PartnerArchiveModal.propTypes = {
  partner: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  listings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onClickSubmit: PropTypes.func.isRequired,
}

export default PartnerArchiveModal
